import React from 'react';

import getOS from './getOS';

import playstore from '../imgs/playstore.png';
import playstore2x from '../imgs/playstore@2x.png';
import appstore from '../imgs/appstore.png';
import appstore2x from '../imgs/appstore@2x.png';

export default function() {
  const OS = getOS();

  const iOSDownload = <a
    className="App-download"
    href="https://itunes.apple.com/us/app/noa-rider/id1141338413?ls=1&mt=8"
  >
    <img
      className="App-appstore-badge"
      src={appstore}
      srcSet={`${appstore2x} 2x`}
      alt="Download on the App Store"
    />
  </a>;

  const AndroidDownload = <a
    className="App-download"
    href="https://play.google.com/store/apps/details?id=one.noatech.rider"
  >
    <img
      className="App-appstore-badge"
      src={playstore}
      srcSet={`${playstore2x} 2x`}
      alt="Get it on Google Play"
    />
  </a>;

  if (OS === 'iOS') {
    return <div className="App-Card-action">
      {iOSDownload}
    </div>
  }

  if (OS === 'Android') {
    return <div className="App-Card-action">
      {AndroidDownload}
    </div>
  }

  return <div className="App-Card-action">
    {iOSDownload}{AndroidDownload}
  </div>

}



// WEBPACK FOOTER //
// ./src/lib/AppLinks.js